import React, { useCallback, useMemo } from "react";
//import SidePanel from '../SidePanel/SidePanel'
import axios from "axios";
import AdminApplications from "../AdminApplications/AdminApplications";
import { AdminMenu } from "../AdminMenu/AdminMenu";
import AdminTasks from "../AdminTasks/AdminTasks";
import { baseUrl } from "../assets/Animations";
import Dashboard from "../Dashboard/Dashboard";
import NeedsToResetPassword from "../NeedsToResetPassword";
import NoteArea from "../NoteArea/NoteArea";
import StudentDatabase from "../StudentDatabase/StudentDatabase";
import TeacherDatabase from "../TeacherDatabase";
import "./admin-master.css";
//import SidePanel from '../SidePanel/SidePanel'
import BlogCreator from "../Blog/BlogCreator";
import BlogReview from "../Blog/BlogReview/BlogReview";
import CancellationSpreadsheet from "../CancellationSpreadsheet/CancellationSpreadsheet";
import { ErrorPopup } from "../ErrorPopup/ErrorPopup";
import FamiliesToWatch from "../FamiliesToWatch/FamiliesToWatch";
import InquiryDatabase from "../InquiryDatabase/InquiryDatabase";
import InvoiceViewMaster from "../InvoiceViewMaster/InvoiceViewMaster";
import CreateEvent from "../NoteArea/CreateEvent/CreateEvent";
import SchoolSEO from "../SchoolSEO/SchoolSEO";
import StudentModal2022 from "../StudentModal2022/StudentModal2022";
import TempDashboard from "../TempDashboard/TempDashboard";
import Timesheets from "../Timesheets/Timesheets";
import "./admin-master.css";

import StudentWorkflows2022 from "../AdminWorkflows/StudentWorkflows2022";
import Calendar from "../Calendar/Calendar";
import { disconnectSocket, socket } from "../service/socket";
import TaxInfoView from "../TaxInfoView/TaxInfoView";
import TeacherAvailability from "../TeacherAvailability/TeacherAvailability";
import UglyCancellations from "../UglyCancellations/UglyCancellations";

import { Navigate, Outlet } from "react-router-dom";

import {
  MdAccountBalance,
  MdCalendarMonth,
  MdEditDocument,
  MdInfoOutline,
  MdMenuBook,
  MdOutlineDashboard,
  MdSchool,
  MdTaskAlt,
  MdTrendingUp,
} from "react-icons/md";
import ActiveUserSection from "../ActiveUserSection/ActiveUserSection";
import StudentOnboardingFall2023 from "../StudentOnboardingFall2023/StudentOnboardingFall2023";
import StudentOnboardingCardModalFall2023 from "../StudentOnboardingCardModalFall2023/StudentOnboardingCardModalFall2023";
import { getRequestHeaders } from "../api";
import WarningPopup from "../DanitComponents/Modals/WarningPopup/WarningPopup";
import TeacherInvitationScreen from "../TeacherInvitationScreen/TeacherInvitationScreen";
import Proposals from "../Proposals/Proposals";
import StudentModal2023 from "../StudentModal2023/StudentModal2023";
import TaskPage2024 from "../TaskPage2024/TaskPage2024";
import IncomeProjections from "../IncomeProjections/IncomeProjections";
import TeacherCancellations from "../TeacherCancellations/TeacherCancellations";
import Dashboard2024 from "../Dashboard2024/Dashboard2024";
import TimesheetsBilling2025 from "../Billing2025/TimesheetsBilling2025/TimesheetsBilling2025";
import DragAndDropScheduler2025 from "../Scheduling2025/DragAndDropScheduler2025";
import AdminTeacherCalendarConnections from "../AdminTeacherCalendarConnections/AdminTeacherCalendarConnections";
import Financials from "../Financials/Financials";
import WaitlistSummary from "../WaitlistSummary/WaitlistSummary";
import JoshLessonConfirmationTest from "../JoshLessonConfirmationTest/JoshLessonConfirmationTest";
import LessonConfirmationAdmin from "../LessonConfirmationAdmin/LessonConfirmationAdmin";
import TeacherAgreementAdmin from "../TeacherAgreements/TeacherAgreementAdmin";

export const useAdminRoute = (props) => {
  const [currentView, setCurrentView] = React.useState("dashboard");
  const [blogToReview, setBlogToReview] = React.useState("");
  const [needsToReset, setNeedsToReset] = React.useState(Boolean);
  const [showNotes, setShowNotes] = React.useState(false);
  const [createNote, setCreateNote] = React.useState(false);
  const [editNote, setEditNote] = React.useState(false);
  const [sideBarNotes, setSideBarNotes] = React.useState([]);
  const [studentModal, setStudentModal] = React.useState(false);
  const [studentModal2023, setStudentModal2023] = React.useState(false);
  const [invoiceView, setInvoiceView] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [idToLogOut, setIdToLogOut] = React.useState(false);
  const [whosLoggedIn, setWhosLoggedIn] = React.useState([]);
  const [todos, setTodos] = React.useState([]);
  const [studentOnboardingWorkflows, setStudentOnboardingWorkflows] = React.useState([]);
  const [studentOnboardingCardsInUse, setStudentOnboardingCardsInUse] = React.useState([]);
  const [familiesToWatch, setFamiliesToWatch] = React.useState([]);
  const [moreAttentionFamilies, setMoreAttentionFamilies] = React.useState([]);
  const [applications, setApplications] = React.useState([]);
  const [warningPopup, setWarningPopup] = React.useState(false);




  //STUDENT-ONBOARDING-2023-STATE
  const [studentOnboardingModal, setStudentOnboardingModal] = React.useState(false);
  const [rawStudentOnboardingCards, setRawStudentOnboardingCards] = React.useState([]);
  const [waitlistEntities, setWaitlistEntities] = React.useState([]);
  const [rawWaitlistFamilies, setRawWaitlistFamilies] = React.useState([]);
  const [studentOnboardingCards, setStudentOnboardingCards] = React.useState([]);
  const [isConfettiExplosion, setIsConfettiExplosion] = React.useState(false);
  //--------------------------------------------------

  //STUDENT-DATABASE-STATE
  const [studentDatabase, setStudentDatabase] = React.useState([]);

  //TIMESHEET-STATE
  const [openTimesheet, setOpenTimesheet] = React.useState(false);
  const [openInvoice, setOpenInvoice] = React.useState(false)





  let fancyFeast = new Audio("/inquiry.wav");

  let myToken = localStorage.getItem("token");
  let myHeader = useMemo(() => {
    return { headers: { Authorization: `Bearer ${myToken}` } };
  }, [myToken]); 


  const getApplications = useCallback(() => {
    if(props.userData.IsAdmin) {
      axios.get(`${baseUrl}/applications`, myHeader)
      .then((response) => {
        setApplications(response.data);
      })
      .catch((e) => {
        console.log("YIKES " + e);
        console.log(e);
        redirectToAdmin()
      });
    }
  }, [myHeader, props.userData.School]);

  const removeApplication = (id) => {
    setApplications((prevApplications) =>
      prevApplications.filter((app) => app.id !== id)
    );
  };


  const getFamiliesToWatch = useCallback(() => {
    if(props.userData.IsAdmin) {
      axios.get(`${baseUrl}/families-to-watch`, myHeader)
        .then((response) => {
          setFamiliesToWatch(response.data);
        })
        .catch((e) => {
          console.log(e);
          redirectToAdmin()
        });
      axios.get(`${baseUrl}/school-management/more-attention`, myHeader)
        .then((response) => {
          setMoreAttentionFamilies(response.data);
        })
        .catch((e) => {
          console.log(e);
          redirectToAdmin()
        });
    }
  }, [myHeader, props.userData.School]);



  React.useEffect(() => {
    if (props.userData.Name) {
      getApplications();
      getFamiliesToWatch();
      setNeedsToReset(props.userData.NeedsToReset);
      socket.emit("login", props.userData.Name);
    }
    const handleSocketConnection = () => {
      if (document.visibilityState === "visible") {
        if (socket.connected === false) {
          socket.connect();
          socket.emit("login", props.userData.Name);
        }
      } else {
        disconnectSocket();
      }
    };

    window.addEventListener("visibilitychange", handleSocketConnection);
    return () => {
      window.removeEventListener("visibilitychange", handleSocketConnection);
    };
  }, [getApplications, getFamiliesToWatch, props.userData]);

  React.useEffect(() => {
    if (props.userData.Name) {
      getApplications();
      setNeedsToReset(props.userData.NeedsToReset);
      socket.emit("login", props.userData.Name);
    }
  }, [props.userData, getApplications]);


  //--------------------------------------------------


  const playFancyFeast = () => {
    fancyFeast.muted = false;
    fancyFeast.play();
  };

  React.useEffect(() => {
    socket.on("login", (loginInfo) => {
      setWhosLoggedIn([...loginInfo.users]);
      setStudentOnboardingCardsInUse([...loginInfo.studentWorkflows]);
    });

    socket.on("logging-out", (loggingOutInfo) => {
      setWhosLoggedIn([...loggingOutInfo.users]);
      setStudentOnboardingCardsInUse([...loggingOutInfo.studentWorkflows]);
    });

    socket.on("inquiry", (card) => {
      playFancyFeast();
      setStudentOnboardingWorkflows((prev) => [...prev, card]);
    });
    socket.on("openStudentWorkflow", (id) => {
      if (id.emitter !== props.userData.Name) {
        setStudentOnboardingCardsInUse([...studentOnboardingCardsInUse, id]);
        //document.getElementById(id.data).style.border = "2px solid fuchsia"
      }
    });
    socket.on("closeAndSaveStudentWorkflow", (data) => {
      setStudentOnboardingCardsInUse([...data.updatedList]);
    });
    socket.on("closeAndDeleteStudentWorkflow", (packet) => {
      setStudentOnboardingWorkflows((prev) =>
        prev.filter((card) => card.todoId !== packet.data)
      );
    });
  }, [socket]);

  //--------------------------------------------------

  React.useEffect(() => {
    if (studentModal) {
      getNotesAboutModal(
        studentModal.familyId,
        "familyId",
        studentModal.familyName
      );
    } else {
      getFamiliesToWatch();
    }
  }, [studentModal, getFamiliesToWatch]);

  React.useEffect(() => {
    if(openTimesheet) {
      getNotesAboutModal(openTimesheet.teacherId, "timesheetId", openTimesheet.teacherName)
    }
  }, [openTimesheet])

  React.useEffect(() => {
    if(openInvoice) {
      getNotesAboutModal(openInvoice.familyId, "invoiceId", openInvoice.familyName)
    }
  }, [openInvoice])

  React.useEffect(() => {
    if (showNotes.id) {
      getNotes();
    }
  }, [showNotes]);

  const redirectToAdmin = () => {
    const adminLoginPath = "/admin";
      const pathname = window.location.pathname;
      if (pathname !== adminLoginPath) window.location.href = adminLoginPath;
  }

  const getAllFamilies = () => {
    axios
      .get(`${baseUrl}/school-management`, myHeader)
      .then((res) => {
        setStudentDatabase(res.data);
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  }

  const deleteFamilyFromState = () => {
    setWarningPopup({
      type: 'warning',
      title: `Are you sure you want to delete this family?`,
      message: `You cannot undo this.`,
      onConfirm: {
          text: 'Yes, DELETE',
          action: () => deleteFamilyCallback()
      },
      onCancel: {
          text: 'Go Back',
          action: () => setWarningPopup(false)
      }
    })
  }

  const deleteFamilyCallback = () => {
    axios
      .delete(`${baseUrl}/school-management/${studentModal2023.familyId}`, myHeader)
      .then((res) => {
        setStudentModal2023(false);
        closeSideNotesWithAnimation();
        removeFamilyFromStudentDatabase(res.data.familyId)
        setWarningPopup(false)
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  }

  const removeFamilyFromStudentDatabase = (familyId) => {
    setStudentDatabase((prev) => prev.filter((family) => family.familyId !== familyId));
  }

  const getFamilyData = (familyId) => {
    axios
      .get(`${baseUrl}/school-management/${familyId}`, myHeader)
      .then((res) => {
        setStudentModal(res.data);
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  };

  const closeAndSaveFamilyModal = useCallback(() => {
    axios
      .put(
        `${baseUrl}/school-management-new/${studentModal.familyId}`,
        studentModal,
        myHeader
      )
      .then((res) => {
        setStudentModal(false);
        closeSideNotesWithAnimation();
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  }, [myHeader, studentModal]);

  const deleteFamily = useCallback(() => {
    axios
      .delete(`${baseUrl}/school-management/${studentModal.familyId}`, myHeader)
      .then((res) => {
        setStudentModal(false);
        closeSideNotesWithAnimation();
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  }, [myHeader, studentModal.familyId]);

  const getNotes = useCallback(() => {
    axios
      .get(`${baseUrl}/notes/${showNotes.type}/${showNotes.id}`)
      .then((res) => {
        res.data.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });
        setSideBarNotes(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [showNotes.id, showNotes.type]);

  const createNoteFunc = useCallback(() => {
    let myNote = {
      id: Math.random().toString(16).slice(2),
      date: new Date(),
      type: showNotes.type,
      author: props.userData.Name,
      important: false,
      connections: [],
      details: "",
      applicationId: "",
      invoiceId: "",
      onboardingId: "",
      familyId: "",
      tasksId: "",
      teacherId: "",
      timesheetId: "",
      workflowId: "",
      miscId1: "",
      miscId2: "",
      miscId3: "",
      miscId4: "",
      miscId5: "",
      miscId6: "",
      miscId7: "",
      miscId8: "",
      miscId9: "",
      miscId10: "",
      displayName: showNotes.displayName,
    };
    myNote[showNotes.type] = showNotes.id;
    setCreateNote(myNote);
  }, [
    props.userData.Name,
    showNotes.displayName,
    showNotes.id,
    showNotes.type,
  ]);

  const editNotesConnections = useCallback(
    (type, id) => {
      let myNote = createNote;
      myNote[type] = id;
      setCreateNote({ ...myNote });
    },
    [createNote]
  );

  const editEditNotesConnections = useCallback(
    (type, id) => {
      let myNote = editNote;
      myNote[type] = id;
      setEditNote({ ...myNote });
    },
    [editNote]
  );

  const getNotesAboutModal = (id, type, nameToDisplay) => {
      setShowNotes({
        type,
        id,
        displayName: nameToDisplay,
      });
  };

  const sendTheEvent = useCallback(() => {
    //const { ...props } = createNote;
    axios
      .post(`${baseUrl}/notes`, {
        note: {
          id: Math.random().toString(16).slice(2),
          date: new Date(),
          type: createNote.type,
          author: props.userData.Name,
          important: createNote.important,
          connections: createNote.connections,
          details: createNote.details,
          applicationId: createNote.applicationId,
          invoiceId: createNote.invoiceId,
          onboardingId: createNote.onboardingId,
          familyId: createNote.familyId,
          tasksId: createNote.tasksId,
          teacherId: createNote.teacherId,
          timesheetId: createNote.timesheetId,
          workflowId: createNote.workflowId,
          miscId1: createNote.miscId1,
          miscId2: createNote.miscId2,
          miscId3: createNote.miscId3,
          miscId4: createNote.miscId4,
          miscId5: createNote.miscId5,
          miscId6: createNote.miscId6,
          miscId7: createNote.miscId7,
          miscId8: createNote.miscId8,
          miscId9: createNote.miscId9,
          miscId10: createNote.miscId10,
        },
      })
      .then((res) => {
        getNotes();
        setCreateNote(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [
    createNote.applicationId,
    createNote.connections,
    createNote.details,
    createNote.familyId,
    createNote.important,
    createNote.invoiceId,
    createNote.miscId1,
    createNote.miscId10,
    createNote.miscId2,
    createNote.miscId3,
    createNote.miscId4,
    createNote.miscId5,
    createNote.miscId6,
    createNote.miscId7,
    createNote.miscId8,
    createNote.miscId9,
    createNote.onboardingId,
    createNote.tasksId,
    createNote.teacherId,
    createNote.timesheetId,
    createNote.type,
    createNote.workflowId,
    getNotes,
    props.userData.Name,
  ]);

  const editTheEvent = useCallback(() => {
    axios
      .put(`${baseUrl}/notes/${editNote.id}`, {
        note: editNote,
      })
      .then((res) => {
        getNotes();
        setEditNote(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [editNote, getNotes]);

  const deleteTheEvent = useCallback(() => {
    axios
      .delete(`${baseUrl}/notes/${editNote.id}`)
      .then((res) => {
        getNotes();
        setEditNote(false);
      })
      .catch((err) => console.log(err));
  }, [editNote.id, getNotes]);

  const closeSideNotesWithAnimation = () => {
    if(document.getElementById("note-area-wrapper")) {
      document.getElementById("note-area-wrapper").style.opacity = 0
      document.getElementById("note-area-wrapper").style.right = "-350px"
    }
    setTimeout(() => {
      setShowNotes(false);
    }, 300);
  };

  const editStudentInfo = useCallback(
    (theIndex, key, theChange, id) => {
      let student = studentModal;
      if (
        key === "addressLine1" ||
        key === "city" ||
        key === "state" ||
        key === "zipcode" ||
        key === "addressLine2"
      ) {
        student.address[key] = theChange;
      } else if (id === "allRates") {
        student.students[theIndex].allRates[key] = theChange;
      } else if (id === "new-instrument") {
        student.students[theIndex].instrumentList = theChange;
      } else {
        id === "student-info"
          ? (student.students[theIndex][key] = theChange)
          : (student[key] = theChange);
      }
      setStudentModal({ ...student });
    },
    [studentModal]
  );

  const tallyUnArchivedApplications = () => {
    return applications.filter((app) => !app.archived).length;
  };


  //----------student onboarding calls -----------------
  const getStudentOnboardingCards = () => {
    axios.get(`${baseUrl}/student-onboarding`, getRequestHeaders())
    .then((res) => {
      setRawStudentOnboardingCards(res.data)
    })
    .catch((err) => console.log(err))
  }


  const childRoutes = useMemo(
    () => [
      {
        path: "",
        element: <Navigate to="./dashboard" replace />,
        exact: true,
      },
      {
        path: "tasks",
        label: "Tasks",
        icon: <MdTaskAlt />,
        sortOrder: 2,
        children: [
          {
            id: "task-list",
            path: "",
            label: "Task List",
            element: (
              <AdminTasks
                userData={props.userData}
                closeSideNotesWithAnimation={closeSideNotesWithAnimation}
                setShowNotes={setShowNotes}
                sideBarNotes={sideBarNotes}
                getNotesAboutModal={getNotesAboutModal}
                todos={todos}
                setTodos={setTodos}
              />
            ),
          },
          {
            id: "task-board",
            path: "board",
            label: "Task Board",
            element: <TaskPage2024 userData={props.userData} />,
          },
        ],
      },
      {
        path: "teachers",
        label: "Teachers",
        icon: <MdMenuBook />,
        sortOrder: 4,
        children: [
          {
            id: "teacherDatabase",
            path: "database",
            label: "Database",
            element: (
              <TeacherDatabase
                logout={() => props.logout()}
                userData={props.userData}
                user={props.user}
                closeSideNotesWithAnimation={closeSideNotesWithAnimation}
                setShowNotes={setShowNotes}
                getNotesAboutModal={getNotesAboutModal}
                getFamilyData={getFamilyData}
                studentModal2022={studentModal}
                setStudentModal2023={setStudentModal2023}
              />
            ),
          },
          {
            id: "hiring",
            path: "adminapplications",
            label: "Mgmt",
            counter: true,
            counterData: tallyUnArchivedApplications() > 0 ? tallyUnArchivedApplications() : null,
            element: (
              <AdminApplications
                getApplications={getApplications}
                removeApplication={removeApplication}
                applications={applications}
                setApplications={setApplications}
                userData={props.userData}
                getNotesAboutModal={getNotesAboutModal}
                setShowNotes={setShowNotes}
                createNoteFunc={createNoteFunc}
              />
            ),
          },
          {
            id: 'teacher-cancellations',
            path: 'cancellations',
            label: 'Teacher Cancellations',
            counter: false,
            element: <TeacherCancellations />
          },
          {
            id: "calendar-connections",
            path: "calendar-connections",
            label: "Calendar Connections",
            element: (
              <AdminTeacherCalendarConnections userData={props.userData} />
            ),
          },
          {
            id: "josh-lesson-confirmation-test",
            path: "josh-lesson-confirmation-test",
            label: "Josh E2E Test",
            element: (
              <JoshLessonConfirmationTest userData={props.userData} />
            ),
          },
          {
            id: "lesson-confirmations",
            path: "lesson-confirmations",
            label: "Lesson Confirmations",
            element: (
              <LessonConfirmationAdmin userData={props.userData} />
            ),
          },
          {
            id: "teacher-agreements",
            path: "agreements",
            label: "Agreements",
            element: <TeacherAgreementAdmin userData={props.userData} />,
          },
          // {
          //   id: 'scheduling-2025',
          //   path: 'scheduling-2025',
          //   label: 'Scheduling 2025',
          //   counter: false,
          //   element: <Scheduling2025 />
          // },
          // Uncomment the following items when needed
          // {
          //   id: "teacher-onboarding",
          //   path: "adminonboarding",
          //   label: "Onboarding",
          // },
          props.userData.PermissionLevel !== "manager" && {
            id: "teacher-availability",
            path: "adminavailability",
            label: "Availability",
            element: <TeacherAvailability />,
          },
          props.userData.PermissionLevel !== "manager" && {
            id: "ugly-temp-cancellations",
            path: "uglycancellations",
            label: "Ugly Cancellations",
            element: <UglyCancellations />,
          }
        ],
      },
      {
        path: "calendar",
        element: <Calendar userData={props.userData} socket={socket} />,
        label: "Calendar",
        icon: <MdCalendarMonth />,
        sortOrder: 5,
      },
      // { path: '/teacher-onboarding', element: 'teacher-onboarding' && <TeacherWorkflows userData={props.userData} getNotesAboutModal={getNotesAboutModal} setShowNotes={setShowNotes} /> },
      {
        path: "students",
        label: "Students",
        icon: <MdSchool />,
        sortOrder: 3,
        children: [
          {
            id: "studentDatabase",
            path: "admindatabase",
            label: "Database",
            element: (
              <StudentDatabase
                userData={props.userData}
                closeSideNotesWithAnimation={closeSideNotesWithAnimation}
                setShowNotes={setShowNotes}
                getNotesAboutModal={getNotesAboutModal}
                getFamiliesToWatch={getFamiliesToWatch}
                setInvoiceView={setInvoiceView}
                setStudentModal={setStudentModal}
                setStudentModal2023={setStudentModal2023}
                studentModal2023={studentModal2023}
                studentDatabase={studentDatabase}
                setStudentDatabase={setStudentDatabase}
                getAllFamilies={getAllFamilies}
              />
            ),
          },
          {
            id: 'student-waitlist',
            path: 'waitlist',
            label: 'Waitlist',
            element: <WaitlistSummary userData={props.userData} />,
          },
          // Uncomment the following items when needed
          // {
          //   id: "student-onboarding",
          //   path: "adminonboarding",
          //   label: "Onboarding",
          // element: (
          //   <StudentWorkflows
          //     userData={props.userData}
          //     closeSideNotesWithAnimation={closeSideNotesWithAnimation}
          //     setShowNotes={setShowNotes}
          //     sideBarNotes={sideBarNotes}
          //     getNotesAboutModal={getNotesAboutModal}
          //   />
          // ),
          // },
          // {
          //   id: "student-onboarding2",
          //   path: "adminonboarding2",
          //   label: "Onboarding",
          //   element: (
          //     <StudentWorkflows2022
          //       userData={props.userData}
          //       closeSideNotesWithAnimation={closeSideNotesWithAnimation}
          //       setShowNotes={setShowNotes}
          //       sideBarNotes={sideBarNotes}
          //       getNotesAboutModal={getNotesAboutModal}
          //       socket={socket}
          //       workflows={studentOnboardingWorkflows}
          //       setWorkflows={setStudentOnboardingWorkflows}
          //       studentOnboardingCardsInUse={studentOnboardingCardsInUse}
          //       setStudentOnboardingCardsInUse={setStudentOnboardingCardsInUse}
          //     />
          //   ),
          // },
          {
            id: 'student-onboarding-fall-2023',
            path: 'adminonboarding3',
            label: 'Onboarding',
            element: (
              <StudentOnboardingFall2023 
                waitlistEntities={waitlistEntities} setWaitlistEntities={setWaitlistEntities}
                rawWaitlistFamilies={rawWaitlistFamilies} setRawWaitlistFamilies={setRawWaitlistFamilies}
                studentOnboardingCards={studentOnboardingCards} setStudentOnboardingCards={setStudentOnboardingCards}
                setStudentOnboardingModal={setStudentOnboardingModal} 
                setRawStudentOnboardingCards={setRawStudentOnboardingCards}
                rawStudentOnboardingCards={rawStudentOnboardingCards} 
                getStudentOnboardingCards={getStudentOnboardingCards}
                userData={props.userData}
                socket={socket}
                isConfettiExplosion={isConfettiExplosion} setIsConfettiExplosion={setIsConfettiExplosion}
                studentOnboardingCardsInUse={studentOnboardingCardsInUse}
                setStudentOnboardingCardsInUse={setStudentOnboardingCardsInUse}
              />
            )
          },
          {
            id: 'student-scheduling-2025',
            path: 'scheduling',
            label: 'Scheduling',
            element: <DragAndDropScheduler2025 userData={props.userData} />
          },
          // {
          //   id: 'teacher-invitations',
          //   path: 'Proposals',
          //   label: 'Proposals',
          //   element: (
          //     <Proposals userData={props.userData} />
          //   )
          // },
          // props.userData.PermissionLevel !== "manager" && {
          //   id: "families-to-watch",
          //   path: "towatch",
          //   label: "To Watch",
          //   counter: true,
          //   counterData: (familiesToWatch || []).length,
          //   element: (
          //     <FamiliesToWatch
          //       familiesToWatch={familiesToWatch}
          //       moreAttentionFamilies={moreAttentionFamilies}
          //       getFamilyData={getFamilyData}
          //     />
          //   ),
          // },
          // props.userData.PermissionLevel !== "manager" && {
          //   id: "temp-dashboard",
          //   path: "tempdashboard",
          //   label: "Temp Dashboard",
          //   element: <TempDashboard />,
          // },
          // props.userData.PermissionLevel !== "manager" && {
          //   id: "inquiry-database",
          //   path: "inquirydatabase",
          //   label: "Inquiry Database",
          //   element: <InquiryDatabase />,
          // },
        ],
      },
      props.userData.PermissionLevel !== "manager" && {
        path: "dashboard",
        //element: <Dashboard userData={props.userData} />,
        element: <Dashboard2024 userData={props.userData} setStudentModal2023={setStudentModal2023} />,
        label: "Dashboard",
        icon: <MdOutlineDashboard />,
        sortOrder: 1,
      },
      props.userData.PermissionLevel !== "manager" && {
        label: "Billing",
        icon: <MdAccountBalance />,
        sortOrder: 6,
        path: "billing",
        children: [
          {
            id: "timesheets",
            path: "timesheets",
            label: "Timesheets",
            element: (
              <Timesheets
                userData={props.userData}
                openStudentModal={setStudentModal2023}
                setOpenTimesheet={setOpenTimesheet}
                openTimesheet={openTimesheet}
                openInvoice={openInvoice} 
                setOpenInvoice={setOpenInvoice}
                setShowNotes={setShowNotes}
              />
            ),
          },
          {
            id: "spread-sheet",
            path: "spread-sheet",
            label: "Spreadsheet",
            hidden: props.userData.Name !== "Prescott Blackler",
            element: <IncomeProjections />,
          },
          {
            id: "cancellations",
            path: "cancellations",
            label: "Cancellations",
            element: <CancellationSpreadsheet userData={props.userData} />,
          },
          {
            id: "tax-info",
            path: "tax-info",
            label: "Tax Info",
            hidden: props.userData.Name !== "Prescott Blackler",
            element: <TaxInfoView />,
          },
          props.userData.Name === "Prescott Blackler" && {
            id: "financials",
            path: "financials",
            label: "Financials",
            hidden: props.userData.Name !== "Prescott Blackler",
            element: <Financials />,
          },
        ],
      },
      //   props.userData.PermissionLevel !== "manager" && props.userData.Name === "Prescott Blackler" && {
      //   label: "New Billing",
      //   icon: <MdAccountBalance />,
      //   sortOrder: 6,
      //   path: "billing-2025",
      //   children: [
      //     {
      //       id: "timesheets-2025",
      //       path: "timesheets-2025",
      //       label: "Timesheets",
      //       element: (
      //         <TimesheetsBilling2025 userData={props.userData} />
      //       ),
      //     },
      //     {
      //       id: "spread-sheet-2025",
      //       path: "spread-sheet",
      //       label: "Invoices",
      //       hidden: props.userData.Name !== "Prescott Blackler",
      //       element: <IncomeProjections />,
      //     },
      //     {
      //       id: "cancellations-2025",
      //       path: "cancellations",
      //       label: "Payments",
      //       element: <CancellationSpreadsheet userData={props.userData} />,
      //     },
      //   ],
      // },
      props.userData.PermissionLevel !== "manager" && {
        path: "school-seo",
        element: <SchoolSEO userData={props.userData} />,
        label: "SEO",
        icon: <MdTrendingUp />,
        sortOrder: 7,
      },
      props.userData.PermissionLevel !== "manager" && {
        id: "blogs",
        label: "Blogs",
        path: "blogs",
        icon: <MdEditDocument />,
        sortOrder: 8,
        children: [
          {
            id: "write-blog",
            path: "write-blog",
            label: "Write Blog",
            element: (
              <BlogCreator
                reviewing={false}
                userData={props.userData}
                setCurrentView={setCurrentView}
              />
            ),
          },
          {
            id: "my-drafts",
            path: "mydrafts",
            label: "My Drafts",
            element: (
              <BlogReview
                published={false}
                personal={true}
                userData={props.userData}
                setCurrentView={setCurrentView}
                setBlogToReview={setBlogToReview}
              />
            ),
          },
          {
            id: "review",
            path: "review",
            label: "Review",
            element: (
              <BlogReview
                published={false}
                personal={false}
                userData={props.userData}
                setCurrentView={setCurrentView}
                setBlogToReview={setBlogToReview}
              />
            ),
          },
          {
            path: "blogtoreview/:id",
            element: (
              <BlogCreator
                userData={props.userData}
                reviewing={blogToReview}
                setCurrentView={setCurrentView}
              />
            ),
          },
        ],
      },
      props.userData.PermissionLevel !== "manager" && {
        id: "wiki",
        label: "Wiki",
        icon: <MdInfoOutline />,
        externalLink: "https://sites.google.com/view/atharowiki",
        sortOrder: 9,
      },
    ],
    [
      blogToReview,
      props,
      sideBarNotes,
      studentModal,
      studentOnboardingCardsInUse,
      studentOnboardingWorkflows,
      todos,
    ]
  );

  const adminRoute = useMemo(() => {
    return (
      childRoutes && {
        children: childRoutes,
        element: (
          <div className="admin-master">
            <ActiveUserSection whosLoggedIn={whosLoggedIn} />
            {needsToReset && (
              <NeedsToResetPassword
                setNeedsToReset={setNeedsToReset}
                userData={props.userData}
              />
            )}
            <AdminMenu
              setCurrentView={setCurrentView}
              currentView={currentView}
              applications={applications}
              familiesToWatch={familiesToWatch}
              userData={props.userData}
              logout={props.logout}
              whosLoggedIn={whosLoggedIn}
              routes={childRoutes}
            />
            <div className="admin-main">
              <Outlet />
            </div>
            {(showNotes.type !== 'onboardingId' && showNotes) && (
            // {(showNotes && ( 
              <NoteArea
                showNotes={showNotes}
                sideBarNotes={sideBarNotes}
                createNoteFunc={createNoteFunc}
                userData={props.userData}
                setEditNote={setEditNote}
              />
            )}
            {createNote && (
              <CreateEvent
                edit={false}
                createNote={createNote}
                deleteTheEvent={deleteTheEvent}
                setCreateNote={setCreateNote}
                sendTheEvent={sendTheEvent}
                editNotesConnections={editNotesConnections}
              />
            )}
            {editNote && (
              <CreateEvent
                edit={true}
                createNote={editNote}
                deleteTheEvent={deleteTheEvent}
                setCreateNote={setEditNote}
                sendTheEvent={editTheEvent}
                editNotesConnections={editEditNotesConnections}
              />
            )}
            {warningPopup && (
              <WarningPopup warningPopup={warningPopup} />
            )}
            {studentOnboardingModal && (
                <StudentOnboardingCardModalFall2023
                  setStudentOnboardingModal={setStudentOnboardingModal}
                  studentOnboardingModal={studentOnboardingModal}
                  userData={props.userData}
                  setRawStudentOnboardingCards={setRawStudentOnboardingCards}
                  setStudentOnboardingCards={setStudentOnboardingCards}
                  setRawWaitlistFamilies={setRawWaitlistFamilies}
                  setWaitlistEntities={setWaitlistEntities}
                  getFamilyData={setStudentModal2023}
                  setIsConfettiExplosion={setIsConfettiExplosion}
                  setWarningPopup={setWarningPopup}
                  socket={socket}
                  setStudentOnboardingCardsInUse={setStudentOnboardingCardsInUse}
                />
              )}
            {studentModal && (
              <StudentModal2022
                setStudentModal={setStudentModal}
                studentModal={studentModal}
                editStudentInfo={editStudentInfo}
                familyId={studentModal.familyId}
                closeSideNotesWithAnimation={closeSideNotesWithAnimation}
                getNotesAboutModal={getNotesAboutModal}
                setError={setError}
                closeAndSaveFamilyModal={closeAndSaveFamilyModal}
                deleteFamily={deleteFamily}
                setInvoiceView={setInvoiceView}
              />
            )}
            {studentModal2023 && (
              <StudentModal2023 
                familyId={studentModal2023} 
                setStudentModal2023={setStudentModal2023}
                userData={props.userData}
                createNoteFunc={createNoteFunc}
                deleteFamilyFromState={deleteFamilyFromState}
              />
            )}
            {invoiceView && (
              <InvoiceViewMaster
                invoice={invoiceView}
                setInvoiceView={setInvoiceView}
              />
            )}
            {error && <ErrorPopup error={error} setError={setError} />}
          </div>
        ),
      }
    );
  }, [
    childRoutes,
    closeAndSaveFamilyModal,
    createNote,
    createNoteFunc,
    currentView,
    deleteFamily,
    deleteTheEvent,
    editEditNotesConnections,
    editNote,
    editNotesConnections,
    editStudentInfo,
    editTheEvent,
    error,
    invoiceView,
    needsToReset,
    applications,
    familiesToWatch,
    props.logout,
    props.userData,
    sendTheEvent,
    showNotes,
    sideBarNotes,
    studentModal,
    whosLoggedIn,
    studentOnboardingModal,
  ]);

  return adminRoute || {};
};
